Vue.component('admin', {
    props: ['role'],
    template: templates.admin,
    data() {
      return {
        model: {
          isStreamer: false
        }
      }
    },
    mounted() {
        const c = this;
       c.fetchData();
      
       
      },
    methods: {
        fetchData() {
            const c = this;
            if (c.role === true) {
             c.model.isStreamer = true;
            } 
        }
    }
  });